export interface UpdateSafetyState {
  hasActiveRound: boolean;
  hasUnsyncedCommands: boolean;
}

export function canActivateUpdate(state: UpdateSafetyState): boolean {
  return !state.hasActiveRound && !state.hasUnsyncedCommands;
}

export function updateMessage(state: UpdateSafetyState): string {
  if (state.hasUnsyncedCommands) {
    return "Update ready. Sync saved changes before you update.";
  }
  if (state.hasActiveRound) {
    return "Update ready. Finish or abandon this round before you update.";
  }
  return "A safe app update is ready.";
}
